import React, { Component } from 'react'
import { connect } from 'react-redux'
import './doorKey.css'
import {
    setDoorKeyNotificaionPage, popupOpenClose,
    setDeviceLoginPage, setDoorKeyValidationPopUp,
    SetCallNativeMethods
} from '../../action/action'
import {
    gettingKeyFailMsg, gettingKeySuccMsg, tapToUnlockMsg,
    gettingKeyMsg, successfulUnlock, tapToUnlockMsgTenSec,
    gettingKeySuccMsgTenSec, CMSPath
} from '../../config/constant'
import AssaAbloyImage from '../../images/AssaAbloy.png'
import {withTranslation} from 'react-i18next'

window.callFromNative = (key) => {
    try {
        window.compRef.displayMessage(key);
    } catch (e) {
        console.log("error while tring to call js function from Native:", e);
    }
}


class DoorNotification extends Component {
    constructor(props) {
        super(props);
        this.timeOutClear = 0
        this.state = {
            message: null,
            tryAgain: false,
            tryAgainCase: null,
            firstTimeRefresh: false,
            singleUserReqRequest: false
        }
        // window.compRef = this
    }

    closeClick = () => {
        this.setState({singleUserReqRequest: false});        
        this.props.setDoorKeyNotificaionPage(false);
        //window.callFromNative(1);
        if (this.state.firstTimeRefresh) {
            document.location.reload();
        }
    }

    nativeCalls = (SessionToken) => {
        console.log("nativeCalls");
        let reserNO = localStorage.getItem("reservationNo");
        try {
            if (window.android.isEndpointSetupComplete()) {
                this.props.SetCallNativeMethods(false);
                console.log("isEndpointSetupComplete() success");
                if (window.android.getNumberOfMobileKeys() != 0) {
                    console.log("getNumberOfMobileKeys() success and openLock() called")
                    console.log("tapToUnlockMsg");
                    this.setState({ message: tapToUnlockMsg });
                    this.timeOutClear = window.setTimeout(() => {
                        window.android.stopScan();
                        this.setState({ message: tapToUnlockMsgTenSec, tryAgain: true, tryAgainCase: "onKeySuccess" });
                    }, 10000);
                    window.android.openLock();
                } else {
                    console.log("getNumberOfMobileKeys() failed and getMobileKey() called");
                    console.log("reservationNo", reserNO);
                    window.android.getMobileKey(CMSPath.slice(7), SessionToken, reserNO)
                    console.log("gettingKeyMsg")
                    this.setState({ message: gettingKeyMsg });
                }
            } else {
                console.log("isEndpointSetupComplete() failed");
                console.log("reservationNo", reserNO);
                if (reserNO) {
                    if (!this.state.singleUserReqRequest) {

                        console.log("userRegistration() called");
                        window.android.userRegistration(CMSPath.slice(7), SessionToken, reserNO); 
                        this.setState({singleUserReqRequest: true});      
                    }
                    
                    console.log("gettingKeyMsg")
                    this.setState({ message: gettingKeyMsg }); 
                }
            }
        } catch (err) {
            console.log("error while checking digital key", err)
        }
    }

    componentDidMount() {
        let reservationNo = localStorage.getItem("reservationNo");
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            console.log("door Key: no session token or no room login.",
            SessionToken,
            this.props.guestDetail.locationId, this.props.guestDetail.guestToken,
            !this.props.guestDetail.locationId || !this.props.guestDetail.guestToken);
            if (!room || room === "null") {
                this.props.setDoorKeyValidationPopUp(true);
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.");
            }
        } else if (!reservationNo || reservationNo === "null") {
            this.props.setDoorKeyValidationPopUp(true);
        } else {
            this.setState({ message: gettingKeyMsg });
            this.nativeCalls(SessionToken);
            console.log("gettingKeyMsg")
        }
    }
    componentDidUpdate() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        if (this.props.runNativeCalls) {
            this.props.SetCallNativeMethods(false);
            this.setState({ message: gettingKeyMsg, firstTimeRefresh: true });
            this.nativeCalls(SessionToken);
            console.log("componentDidUpdate gettingKeyMsg");
        }
    }
    displayMessage = (key) => {
        switch (key) {
            case 0:
                console.log("displayMessage case 0");
                this.setState({ message: gettingKeyFailMsg, tryAgain: true, tryAgainCase: "GetKeyFail" });
                break;
            case 1:
                console.log("displayMessage case 1");
                this.setState({ message: gettingKeySuccMsg });
                this.timeOutClear = window.setTimeout(() => {
                    window.android.stopScan();
                    this.setState({ message: gettingKeySuccMsgTenSec, tryAgain: true, tryAgainCase: "onKeySuccess" });
                }, 10000);
                break;
            case 2:
                console.log("displayMessage case 2");
                this.setState({
                    //  message: successfulUnlock,
                    tryAgain: false
                });
                window.clearTimeout(this.timeOutClear);
                window.android.stopScan();
                break;
            default:
                console.log("no case match.");
        }
    }

    tryAgainClick = () => {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        if (this.state.tryAgainCase === "GetKeyFail") {
            this.setState({ message: gettingKeyMsg });
            this.nativeCalls(SessionToken);
        }

        if (this.state.tryAgainCase === "onKeySuccess") {
            this.setState({ message: tapToUnlockMsg });
            this.nativeCalls(SessionToken);
        }
        this.setState({ tryAgain: false });
    }

    render() {
        const {t} = this.props
        let message = this.state.message ? this.state.message.split('\n').map((item, i) => {
            return <p
                style={{
                    color: "#fff",
                    fontSize: "20px",
                    paddingLeft: "20px"
                }}
                key={i}>{item}</p>;
        }) : "  "
        return (
            <div style={{
                background: "#000",
                zIndex: 999,
                position: 'absolute',
                top: 0,
                bottom: 0,
                width: "100%",
                height: window.innerHeight,
                minHeight: window.innerHeight,
                maxHeight: window.innerHeight,
                display: 'flex',
                overflow: "hidden"
            }}>
                {
                    true ?
                        <div style={{
                            position: "absolute",
                            width: "200px",
                            maxWidth: "200px",
                            minWidth: "200px",
                            padding: "6rem 0rem",
                        }}>
                            <div
                                style={{
                                    border: "red",
                                    background: "#130f07",
                                    color: "#fff",
                                    //width: "50%",
                                   //height: "70%",
                                    borderRadius: "6px",
                                }}
                            >
                                {
                                    this.state.message ?
                                        <div
                                            style={{
                                                color: "#fff",
                                                fontSize: "20px",
                                                padding: "5px",
                                                width: "97%",
                                                 height: "70%",
                                            }}>
                                            {message}
                                        </div>
                                        : null
                                }
                            </div>
                            {
                                this.state.tryAgain ?
                                    <div className="tryAgainButton">
                                        <button onClick={this.tryAgainClick}>
                                            {t('door_key.activate_key')}
                                        </button>
                                    </div> : null
                            }
                        </div> :
                        <div
                            style={{
                                color: "#fff",
                                display: "flex",
                                fontSize: "35px",
                                margin: "auto 8rem"
                            }}
                        >
                            {t('door_key.wait')} . . .
                    </div>
                }
                <div
                    style={{
                        display: "block",
                        bottom: "1rem",
                        left: "1rem",
                        position: "absolute"
                    }}>
                    <img
                        style={{
                            width: "6rem",
                            height: "3rem"
                        }} src={AssaAbloyImage} />
                </div>
                <div class="doorkey" onClick={this.closeClick}>
                    <a
                        style={{ background: "#fff" }}
                        href="javascript:void(0);" class="tile-container">
                        <i
                            style={{ color: "#000" }}
                            class="fas fa-close"></i></a>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentWidget: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        reservationNo: state.store.reservationNo,
        runNativeCalls: state.store.doorKey.runNativeCalls
    }
}
export default connect(
    mapStateToProps,
    {
        setDoorKeyNotificaionPage,
        popupOpenClose,
        setDeviceLoginPage,
        setDoorKeyValidationPopUp,
        SetCallNativeMethods
    }
)(withTranslation('translations')(DoorNotification));